'use strict';

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';

//import Modal from '@/views/common/modals/ModalImport';
import Menu from './Menu';
import Stats from './Stats';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { assignmentsOperations, assignmentsSelectors } from '@/state/domains/assignments';
import { getWeekDates } from '@/state/utilities';

import s from './styles.scss';

const Main = connect(
	(state, props) => ({
		slug: appSelectors.getSlug(state, props),
		pageUrl: appSelectors.getPageUrl(state, props),
		username: appSelectors.getPageUsername(state, props),
		isPageLoaded: appSelectors.isPageLoaded(state, props),
		pageUser: usersSelectors.getPageUser(state, props),
	}),
	{
		fetchUser: usersOperations.fetchUser,
		fetchUserWeeklyAttempts: attemptsOperations.fetchUserWeeklyAttempts,
		getWeekNav: appOperations.getWeekNav,
		getAssignments: assignmentsOperations.getAssignments,
		setPageLoaded: appOperations.setPageLoaded,
	}
)(
	(props) => {

		const {
			slug,
			pageUrl,
			username,
			isPageLoaded,
			pageUser,
			setModalClose,
			fetchUser,
			fetchUserWeeklyAttempts,
			setPageLoaded,
			getWeekNav,
			getAssignments,
		} = props;
		
		const tzOffset = format(new Date(), 'xxx');
		let weekDates = getWeekDates(slug);

		useEffect(
			() => {
				if (!isPageLoaded) {
					if (!pageUser) {
						fetchUser(username);
					} else {

						const p1 = getWeekNav(pageUser.username, slug);
						const p2 = fetchUserWeeklyAttempts(
							pageUser.username,
							slug,
							tzOffset,
							(new Date()).getTimezoneOffset()
						);

						const p3 = getAssignments(
							pageUser.username,
							weekDates.map(d => format(d, 'yyyy-MM-dd'))
						);

						Promise.all([ p1, p2, p3 ]).then(
							([ r1, r2, r3 ]) => {
								if (r1.success && r2.success && r3.success) {
									setPageLoaded(pageUrl);
								}
							}
						);
						window.navigator.geolocation.getCurrentPosition(console.log);
					}
				}
			},
			[ pageUser, pageUrl ]
		);

		if (!isPageLoaded) {
			return <div />;
		}

		const weekStart = format(weekDates[ 0 ], 'EEE MMM do');
		const weekEnd = format(weekDates[ 4 ], 'EEE MMM do');
		const dates = weekDates.map(d => format(d, 'yyyy-MM-dd'));

		return (
			<div className={ s.root }>
				<Stats
					user={ pageUser }
					username={ pageUser.username }
					weekDates={ weekDates }
					dates={ dates }
				/>
			</div>
		);
	}
);

export const components = {
	overlays: [
		//Modal,
		Menu,
	],
	main: Main,
};

export default Main;
